import { render, staticRenderFns } from "./TasksView.vue?vue&type=template&id=9605c742&scoped=true&"
import script from "./TasksView.vue?vue&type=script&lang=js&"
export * from "./TasksView.vue?vue&type=script&lang=js&"
import style0 from "./TasksView.vue?vue&type=style&index=0&id=9605c742&lang=scss&scoped=true&"
import style1 from "./TasksView.vue?vue&type=style&index=1&id=9605c742&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9605c742",
  null
  
)

export default component.exports